import { gql } from "@apollo/client";

export const GOOGLE_REVIEWS_QUERY = gql`
  query GoogleReviews {
    googleReviews {
      id
      reviewerName
      rating
      reviewText
      reviewDate
      position
    }
  }
`;

export const ADMIN_GOOGLE_REVIEWS_QUERY = gql`
  query AdminGoogleReviews {
    adminGoogleReviews {
      id
      reviewerName
      rating
      reviewText
      reviewDate
      active
      position
      createdAt
    }
  }
`;

export const ADMIN_UPSERT_GOOGLE_REVIEW_MUTATION = gql`
  mutation AdminUpsertGoogleReview(
    $id: ID
    $reviewerName: String!
    $rating: Int!
    $reviewText: String!
    $reviewDate: String
    $active: Boolean
    $position: Int
  ) {
    adminUpsertGoogleReview(
      input: {
        id: $id
        reviewerName: $reviewerName
        rating: $rating
        reviewText: $reviewText
        reviewDate: $reviewDate
        active: $active
        position: $position
      }
    ) {
      googleReview {
        id
        reviewerName
        rating
        reviewText
        reviewDate
        active
        position
      }
      errors
    }
  }
`;

export const ADMIN_DELETE_GOOGLE_REVIEW_MUTATION = gql`
  mutation AdminDeleteGoogleReview($id: ID!) {
    adminDeleteGoogleReview(input: { id: $id }) {
      success
      errors
    }
  }
`;
